import { apiClient } from "./api-client";
import { toArray } from "./api-utils";
import type { AddProjectRequest } from "./api-types";
import type { ProjectsUsersAndGroups, TriyoProject } from "@/types/models";

export const ProjectsApi = {
  getUserProjects: async (): Promise<TriyoProject[]> => {
    const res = await apiClient.get<unknown>("/projects/getuserprojects");
    return toArray<TriyoProject>(res.data, "Projects", "projects");
  },

  /** Members/owners roster for the Create Deal wizard (requires Projects/View). */
  getUsersAndGroups: async (): Promise<ProjectsUsersAndGroups> => {
    const res = await apiClient.get<ProjectsUsersAndGroups>("/projects/GetProjectsUsersAndGroups");
    return res.data ?? {};
  },

  /** Creates a project ("Deal"); resolves the created project with its new Id. */
  addProject: async (payload: AddProjectRequest): Promise<TriyoProject> => {
    const res = await apiClient.post<TriyoProject>("/projects/AddProject", payload);
    return res.data ?? {};
  },
};
